import { render, staticRenderFns } from "./edit_break_dialog.vue?vue&type=template&id=108cc6d5&scoped=true&"
import script from "./edit_break_dialog.vue?vue&type=script&lang=js&"
export * from "./edit_break_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108cc6d5",
  null
  
)

export default component.exports